import { Checkbox, CheckboxProps, FormControlLabel, FormControlLabelProps, FormHelperText } from '@mui/material';
import { Control, Controller, FieldValues, Path } from 'react-hook-form';
import { mergeSx } from '../../../utils/styles';

type FormCheckboxFieldProps<T extends FieldValues> = {
  name: Path<T>;
  control: Control<T>;
  label: string;
  error?: boolean;
  helperText?: string;
  disabled?: boolean;
  FormControlLabelProps?: Omit<FormControlLabelProps, 'control' | 'label'>;
  CheckboxProps?: Omit<CheckboxProps, 'checked' | 'disabled'>;
};

const FormCheckboxField = <T extends FieldValues>({
  name,
  control,
  label,
  error,
  helperText,
  disabled,
  FormControlLabelProps,
  CheckboxProps,
}: FormCheckboxFieldProps<T>) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <>
          <FormControlLabel
            control={
              <Checkbox
                {...field}
                checked={field.value}
                disabled={disabled}
                {...CheckboxProps}
                sx={mergeSx({ color: error ? 'error.main' : 'inputStyles.focus' }, CheckboxProps?.sx)}
              />
            }
            label={label}
            {...FormControlLabelProps}
          />
          {error && helperText && <FormHelperText error>{helperText}</FormHelperText>}
        </>
      )}
    />
  );
};

export default FormCheckboxField;
